module.exports = __webpack_public_path__ + "img/creditallInvest.ccc2d46a.png";